import { FThemeDefaultGraphicViewer } from "./f-theme-default-graphic-viewer";

export class FThemeDefaultJaJpGraphicViewer extends FThemeDefaultGraphicViewer {}
